import Crud from '../components/Vacations/Crud'
import Entity from '../components/Vacations/Entity'

let routes = {
    path: '/point-mirror',
    component: resolve => require(['../components/layout/App'], resolve),
    children: [
        {
            path: '/vacations/',
            name: 'Gerenciar Férias',
            component: Crud
        },
        {
            path: '/vacation/:id?',
            name: 'Novo Registro de Férias',
            component: Entity
        }
    ]
};

export default routes



// WEBPACK FOOTER //
// ./src/router/vacations.js